<cjm-input-wrapper
	inputId="countrySelectControl"
	[label]="label"
	[ngClass]="{
		'u-margin-bottom': countrySelectControl.value === countryOptions.Other
	}"
>
	<select #input cypressTag="CountrySelect.Select.Input" [formControl]="countrySelectControl" [title]="label">
		@for (type of countryOptionValues; track type) {
			<option [value]="type">
				{{ type }}
			</option>
		}
	</select>
</cjm-input-wrapper>

@if (countrySelectControl.value === countryOptions.Other) {
	<cjm-input-wrapper inputId="form" cypressTag="CountrySelect.Other.Input" [label]="otherLabel">
		<input
			#otherField
			#input
			type="text"
			[formControl]="form"
			[placeholder]="otherPlaceholder"
			[title]="otherLabel ? otherLabel : otherPlaceholder"
		/>
	</cjm-input-wrapper>
}
